import React from 'react';
import './PriorityBadge.scss';

export interface PriorityBadgeProps {
  position: number;
  prefix?: string;
  className?: string;
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({
  position,
  prefix = '',
  className = ''
}) => {
  return (
    <span
      className={`cmx-priority-badge ${className}`.trim()}
      aria-label={`Priority ${prefix}${position}`}
      data-testid="priority-badge"
    >
      {prefix}{position}
    </span>
  );
};

PriorityBadge.displayName = 'PriorityBadge';
export default PriorityBadge;
